import { ValidateData } from "../utils/validate-data";

export enum DocumentsType {
  CO1C = "Cedula de ciudadanía",
  CO1L = "Registro civil",
  CO1E = "Cedula de extranjería",
  CO1T = "Tarjeta de identidad",
  CO1V = "Permiso especial de permanencia",
  CO1P = "Pasaporte",
  CO1W = "Permiso protección temporal",
  CO1D = "Carnet diplomático",
  CO1N = "Nit",
}

export class FindDocumentsTypeEnum {
  static find(code: string): string {
    return !ValidateData.emptyString(DocumentsType[code]) ? DocumentsType[code]: null
  }
}

export class FindDocumentsTypeEnumNumber {

  static find(typeDocument: number): string {

    const documentTypeEntreprise = [

      { name: 'CO1N', value: 1},

      { name: 'CO1C', value: 2 },

      { name: 'CO1E', value: 3 },

      { name: 'CO1P', value: 7 },

      { name: 'CO1N', value: 8 }

    ];

    return !ValidateData.emptyObject(documentTypeEntreprise.find(document => document.value === typeDocument)) ?
            documentTypeEntreprise.find(document => document.value === typeDocument).name : '';

  }
}
